import { APIRoute } from '@/modules/utils'

export const Route: APIRoute = {
  method: 'GET',
  path: '/v2/stripe/pk',
}

export type SearchParams = {
  plan?: string
}

export type Response = {
  key: string
  merchantId: string
}
